<div class="flex flex-wrap gap-3">
  @for (option of options(); track option.value) {
  <button
    type="button"
    class="chip text-sm"
    [class.selected]="isSelected(option.value)"
    (click)="selectOption(option.value)"
    [disabled]="disabled"
  >
    {{ option.label }}
  </button>
  }
</div>
